import { createSlice } from '@reduxjs/toolkit';

export const calendarSlice = createSlice({
    name: "calendar",
    initialState: [],
    reducers: {
        set: (state, action) => {
            state = action.payload;
            return state;
        }
    }
})

export const calendarActions = calendarSlice.actions;

export default calendarSlice.reducer;